import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import stringify from 'csv-stringify/lib/es5/sync';

import DownloadCodes from './DownloadCodes';
import NavigateAwayPrompt from '../../components/NavigateAwayPrompt';
import { getRewardsForRedemption } from '../../selectors/createCampaign';
import { getCampaign } from '../../selectors/campaigns';
import { campaignReset } from '../../actions/createCampaign';
import PropTypeCampaign from '../../utilities/propTypes/PropTypeCampaign';
import { CampaignStatuses } from '../../constants';

const mapStateToProps = state => ({
  campaign: getCampaign(state, state.createCampaign.transactionHash),
  rewards: getRewardsForRedemption(state),
  abandonRewardsDownloadMessage: state.app.abandonRewardsDownloadMessage,
});

const mapDispatchToProps = dispatch => ({
  onResetCampaign: () => dispatch(campaignReset()),
});

export class DownloadCodesContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasDownloadedCodes: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleRecreateCampaign = this.handleRecreateCampaign.bind(this);
  }

  handleClick() {
    const { rewards, onComplete } = this.props;
    const csv = stringify(rewards, { columns: ['#', 'url'], header: true });
    onComplete();
    fileDownload(csv, 'rewardCodes.csv');
    this.setState({ hasDownloadedCodes: true });
  }

  handleRecreateCampaign() {
    const { onResetSteps, onResetCampaign } = this.props;
    onResetSteps();
    onResetCampaign();
  }

  render() {
    const { abandonRewardsDownloadMessage, campaign } = this.props;
    return (
      <React.Fragment>
        <NavigateAwayPrompt
          when={!this.state.hasDownloadedCodes || !campaign.status.is(CampaignStatuses.failed)}
          message={abandonRewardsDownloadMessage}
        />
        <DownloadCodes
          campaign={campaign}
          onDownloadClick={this.handleClick}
          onRecreateClick={this.handleRecreateCampaign}
        />
      </React.Fragment>
    );
  }
}

DownloadCodesContainer.displayName = 'DownloadCodesContainer';

DownloadCodesContainer.defaultProps = {
  campaign: {},
  onComplete: noop,
  rewards: [],
  abandonRewardsDownloadMessage: '',
  onResetSteps: noop,
  onResetCampaign: noop,
};

const rewardType = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]));
DownloadCodesContainer.propTypes = {
  campaign: PropTypes.shape(PropTypeCampaign),
  onComplete: PropTypes.func,
  rewards: PropTypes.arrayOf(rewardType),
  abandonRewardsDownloadMessage: PropTypes.string,
  onResetSteps: PropTypes.func,
  onResetCampaign: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadCodesContainer);



// WEBPACK FOOTER //
// ./src/containers/createCampaign/DownloadCodesContainer.js